import React from 'react';
import './TutorialModal.css';

const TutorialModal = ({ onClose }) => {
  return (
    <div className="tutorial-overlay" onClick={onClose}>
      <div className="tutorial-panel" onClick={(e) => e.stopPropagation()}>
        <div className="tutorial-header">
          <h2>Welcome to VividYear!</h2>
          <button onClick={onClose} className="tutorial-close-btn">&times;</button>
        </div>
        <div className="tutorial-content">
          <p>Your global guide to the world's most exciting events.</p>
          
          {/* --- NEW: Added a step for the hamburger menu --- */}
          <div className="tutorial-step">
            <div className="tutorial-icon menu-icon">☰</div>
            <div>
              <h4>Browse All Events</h4>
              <p>Click the menu icon in the top-left to open the sidebar and see a list of all upcoming events.</p>
            </div>
          </div>
          {/* ----------------------------------------------- */}

          <div className="tutorial-step">
            <div className="tutorial-icon search-icon">🔍</div>
            <div>
              <h4>Search & Discover</h4>
              <p>Use the search bar at the top to find events or filter by country.</p>
            </div>
          </div>
          
          <div className="tutorial-step">
            <div className="tutorial-icon filter-icon">🎨</div>
            <div>
              <h4>Filter Your Interests</h4>
              <p>Use the filter buttons to narrow down events by category or continent.</p>
            </div>
          </div>

          <div className="tutorial-step">
            <div className="tutorial-icon click-icon">👆</div>
            <div>
              <h4>View Event Details</h4>
              <p>Click any event on the calendar or in the sidebar to view its details and plan your trip.</p>
            </div>
          </div>
        </div>
        <div className="tutorial-footer">
          <button onClick={onClose} className="tutorial-action-btn">Get Started</button>
        </div>
      </div>
    </div>
  );
};

export default TutorialModal;
